import { EyeOutlined } from "@ant-design/icons";
import { EmailTemplateLayout } from "@rumble-it/common-lib/types/models/EmailTemplateLayout.interface";
import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";

export const emailTemplateLayoutColumns: TableColumnsType<EmailTemplateLayout> =
  [
    {
      title: "Titel",
      dataIndex: "title",
      key: "title",
      render: (text: string, record) =>
        text ? (
          <Link to={`/email-templates/layouts/${record.id}`}>{text}</Link>
        ) : null,
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: any, record) => (
        <Link to={`/email-templates/layouts/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];
